module.exports = __webpack_public_path__ + "img/1763639271437-wide-eli-yusnetti-1472024110630001-2021-04-22-095047.jpg.ae40626b.webp";